export const description =
  "Installer un poêle à granulés (rendement ≥ 87 %, Flamme Verte 7★) en cumulant MaPrimeRénov’ + Prime CEE + Coup de pouce + éco-PTZ + TVA 5,5 % 2026.";
